/* eslint-disable no-underscore-dangle */
const UIProductItem = require('./productItem');
const UIProductDesc = require('./productDesc');
const ViewSwitch = require('./productsViewSwitch');
const utils = require('../../utils');

/** Product grid view component */
function UIProductsViewGrid() {
  let productItem;
  let productItems;

  this.__afterGridViewUpdatedRegistry = [];
  this.__element = document.querySelector('.resultGrid');

  if (this.__element !== null) {
    productItems = document.querySelectorAll('article.product');
    this.__viewSwitch = new ViewSwitch();
    this.__productItems = [];
    this.__visibleProductDesc = null;

    for (let i = 0; i < productItems.length; i++) {
      productItem = new UIProductItem(productItems[i]);
      productItem.__desc = new UIProductDesc(
        productItem.__element,
        this.viewProductDesc.bind(this)
      );
      this.__productItems.push(productItem);
    }

    this.init();
  }
}

/**
 * Initialize
 * @returns {UIProductsViewGrid}
 */
UIProductsViewGrid.prototype.init = function init() {
  const debouncedUpdateProductsHeight =
    utils.debounce(() => {
      setTimeout(this.updateProductsHeight.bind(this), 0);
    }, 250);

  this.attachResizeHandler();
  window.addEventListener('load', debouncedUpdateProductsHeight, false);
  const lozadImages = document.querySelectorAll('.resultGrid picture.lozadImage');

  // We have to resize grid items anytime a lazy loaded image is loaded and that happens
  // when <img> element is added to <picture className="lozadImage">
  for (let i = 0; i < lozadImages.length; i++) {
    const observer = new MutationObserver(mutationObserverCallback);

    observer.observe(
      lozadImages[i],
      {
        childList: true
      }
    );
  }

  function mutationObserverCallback(mutationList, observerInst) {
    mutationList.find(
      (mutation) => mutation.type === 'childList' &&
        mutation.addedNodes.length === 1 &&
        mutation.addedNodes[0].tagName === 'IMG'
    ).addedNodes[0].addEventListener('load', () => {
      debouncedUpdateProductsHeight();
      observerInst.disconnect();
    });
  }
};

/**
 * Attaches resize event to window
 */
UIProductsViewGrid.prototype.attachResizeHandler = function attachResizeHandler() {
  const debouncedOnResize =
    utils.debounce(() => {
      setTimeout(this.onResize.bind(this), 0);
    }, 250);

  window.addEventListener('resize', debouncedOnResize, false);

};

/**
 * Handle resize event using debouncing
 */
UIProductsViewGrid.prototype.onResize = function onResize() {
  this.updateGridView();
};

UIProductsViewGrid.prototype.updateGridView = function updateGridView() {
  this.updateProductsHeight();
  this.hideVisibleDesc();
  this.__afterGridViewUpdatedRegistry.forEach((callback) => callback(this));
};

UIProductsViewGrid.prototype.afterGridViewUpdated = function afterGridViewUpdated(callback) {
  this.__afterGridViewUpdatedRegistry.push(callback);
};

/**
 * Updates products height per row
 */
UIProductsViewGrid.prototype.updateProductsHeight = function updateProductsHeight() {
  const productsCountInRow = this.getProductsCountInRow();
  let currentRow = [];
  let innerMaxHeights = [];
  let innerComponents;
  let cHeight;
  let product;

  const visibleProducts = getVisibleProducts(this.__productItems);

  // Goes through all the products
  for (let i = 0, productCount = visibleProducts.length; i < productCount; i++) {
    product = visibleProducts[i];

    currentRow.push(product);

    // Find max height of inner components per row
    innerComponents = product.getInnerComponents();
    $(innerComponents.map((o) => o.__element)).height('auto');
    for (let j = 0, cLen = innerComponents.length; j < cLen; j++) {
      cHeight = innerComponents[j].getHeight();
      if (innerMaxHeights[j] === undefined || innerMaxHeights[j] < cHeight) {
        innerMaxHeights[j] = cHeight;
      }
    }

    // If last product in row, set the heights and reset them
    if ((i + 1) % productsCountInRow === 0 || (i + 1) === productCount) {
      this.setRowHeights(currentRow, innerMaxHeights);
      currentRow = [];
      innerMaxHeights = [];
    }
  }
};

/**
 * Sets height of product and inner elements to the same height per row
 * @param {Array} row
 * @param {Array} innerHeights
 */
UIProductsViewGrid.prototype.setRowHeights = function setRowHeights(row, innerHeights) {
  let product;
  let innerComponents;

  for (let i = 0, len = row.length; i < len; i++) {
    product = row[i];
    innerComponents = product.getInnerComponents();

    for (let j = 0, cLen = innerComponents.length; j < cLen; j++) {
      if (innerHeights[j] > 0) {
        innerComponents[j].setHeight(innerHeights[j]);
      }
    }
  }
};

/**
 * Gets the width of the product
 * @returns {int}
 */
UIProductsViewGrid.prototype.getWidth = function getWidth() {
  return this.__element.offsetWidth;
};

/**
 * Gets the number of products in row
 * @returns {int}
 */
UIProductsViewGrid.prototype.getProductsCountInRow = function getProductsCountInRow() {
  const firstProduct = getVisibleProducts(this.__productItems)[0];
  const gridWidth = this.getWidth();
  const productWidth = firstProduct.getWidth();
  return Math.round(gridWidth / productWidth);
};

/**
 * Gets the last product in row
 * @param {element} product
 * @returns {element}
 */
UIProductsViewGrid.prototype.getLastInRow = function getLastInRow(product) {
  const productsCountInRow = this.getProductsCountInRow();
  let isFoundRow = false;
  let prod;

  if (product && product[0] !== undefined) {
    prod = product[0];
  } else {
    prod = product;
  }

  const visibleProducts = getVisibleProducts(this.__productItems);

  for (let i = 0, productCount = visibleProducts.length; i < productCount; i++) {
    if (prod.id === visibleProducts[i].getId()) {
      isFoundRow = true;
    }
    if (isFoundRow && (i + 1) % productsCountInRow === 0) {
      return visibleProducts[i].getElement();
    }
  }

  return visibleProducts[visibleProducts.length - 1].getElement();
};

/**
 * Hides currently visible description
 */
UIProductsViewGrid.prototype.hideVisibleDesc = function hideVisibleDesc() {
  if (this.__visibleProductDesc) {
    this.__visibleProductDesc.close();
  }
};

/**
 * Move product description below products row or hide it (move back to it's product)
 * @param {element} product
 * @param {object} desc
 * @param {boolean} show
 */
UIProductsViewGrid.prototype.viewProductDesc = function viewProductDesc(product, desc, show) {
  let lastProductInRow;
  if (show) {
    if (this.__visibleProductDesc && this.__visibleProductDesc !== desc) {
      this.__visibleProductDesc.close();
    }
    this.__visibleProductDesc = desc;
    lastProductInRow = this.getLastInRow(product);
    this.__element.insertBefore(desc.__descWrapper, lastProductInRow.nextSibling);
  } else {
    desc.__element.appendChild(desc.__descWrapper);
  }

  const debouncedUpdateProductsHeight =
    utils.debounce(() => {
      setTimeout(this.updateProductsHeight.bind(this), 0);
    }, 250);

  debouncedUpdateProductsHeight();
};

UIProductsViewGrid.prototype.getSortedProducts = function getSortedProducts() {
  const productsElements = document.querySelectorAll('article.product');
  const products = this.__productItems;

  return Array.from(productsElements)
    .filter((productElement) => productElement.id !== '' &&
      products.find(filterByProductId(productElement.id)))
    .map((productElement) => products.find(filterByProductId(productElement.id)));
};

function filterByProductId(id) {
  return (item) => item.getId() === id;
}

function getVisibleProducts(products) {
  return products.filter((item) => item.isVisible());
}

module.exports = UIProductsViewGrid;
